import * as React from 'react';
import styled from 'styled-components';
import { useSlate } from 'slate-react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import View from '@sdk/components/primitives/View';
import DisplayText from '@sdk/components/ui/DisplayText';
import Row from '@sdk/components/ui/spacing/Row';

import TrashSvg from '@web/assets/svg/Icons/16/trash-gray.svg';
import EditSvg from '@web/assets/svg/Icons/16/edit-gray.svg';
import CloseSvg from '@web/assets/svg/Icons/16/close-gray.svg';

import { unwrapLink } from '../../helpers/utils';

import LinkIconButton from './LinkIconButton';

const OuterContainer = styled(Row)`
  display: flex;
  flex: 1;
  margin: 1px;
  overflow: hidden;
`;

const LinkContainer = styled(View)`
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-left: 10px;
`;

const ButtonsContainer = styled(Row)`
  border-left: 1px solid ${({ theme }): string => theme.colors.separatorOnWhite};
  padding-left: 20px;
`;

const LinkTextContainer = styled.a`
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
`;

const LinkText = styled(DisplayText)`
  color: ${({ theme }): string => theme.colors.primary};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

type Props = {
  url: string;
  editLink: () => void;
  close: () => void;
};

const ViewLink: React.FC<React.PropsWithChildren<Props>> = ({ url, close, editLink }) => {
  const editor = useSlate();
  const prefixedUrl =
    url.startsWith('http://') || url.startsWith('https://') ? url : `http://${url}`;

  const removeLink = (): void => {
    close();
    unwrapLink(editor);
  };

  return (
    <OuterContainer>
      <LinkContainer>
        <LinkTextContainer href={prefixedUrl} target="_blank" rel="noreferrer">
          <LinkText fontSize={14} themeColor={ThemeColorType.primary}>
            {url}
          </LinkText>
        </LinkTextContainer>
      </LinkContainer>
      <ButtonsContainer>
        <LinkIconButton onClick={(): void => editLink()}>
          <EditSvg />
        </LinkIconButton>
        <LinkIconButton onClick={(): void => removeLink()}>
          <TrashSvg />
        </LinkIconButton>
        <LinkIconButton onClick={(): void => close()}>
          <CloseSvg />
        </LinkIconButton>
      </ButtonsContainer>
    </OuterContainer>
  );
};

export default ViewLink;
